enum FilterDefinitionTypeConstants {
  UNDEFINED = 'UNDEFINED',
  MULTI_SELECT = 'MULTI_SELECT',
  MULTI_SELECT_TAGS = 'MULTI_SELECT_TAGS',
  RANGE = 'RANGE',
  TEXT = 'TEXT',
  SELECTED_MACHINES = 'SELECTED_MACHINES',
}

export default FilterDefinitionTypeConstants;
